import React, { useRef, useState } from "react";
import user from "../../images/new/artist/user.svg";
import mail from "../../images/new/artist/mail.svg";
import artistTwitter from "../../images/new/artist/twitter.svg";
import artistQuote from "../../images/new/artist/quote.svg";
import pom2089 from "../../images/new/artist/pom2089.png";
import darlyn from "../../images/new/artist/darlyn.png";
import galaxy from "../../images/new/artist/galaxy.png";
import reckless from "../../images/new/artist/reckless.png";
import liska from "../../images/new/artist/liska.png";
import choen from "../../images/new/artist/choen.png";
import freakland from "../../images/new/artist/freakland.png";
import suburban from "../../images/new/artist/suburban.png";
import alyssa from "../../images/new/artist/alyssa.png";
import baka from "../../images/new/artist/baka.png";
import mozhgan from "../../images/new/artist/mozhgan.png";
import veronicaradd from "../../images/new/artist/veronicaradd.png";
import jessica from "../../images/new/artist/jessica.png";
import koinroses from "../../images/new/artist/koinroses.png";
import alba from "../../images/new/artist/alba.png";
import seth from "../../images/new/artist/seth.png";
import geoff from "../../images/new/artist/geoff.png";
import geoff2 from "../../images/new/artist/geoff2.jpg";
import geoff3 from "../../images/new/artist/geoff3.jpg";
import carsola from "../../images/new/artist/carsola.png";
import carsola2 from "../../images/new/artist/carsola2.jpg";
import { useEffect } from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
const options = {
  center: true,
  items: 2,
  loop: true,
  margin: 0,
  nav: true,
  navText: ["<div class='nav-button owl-prev slide-left'></div>", "<div class='nav-button owl-next slide-right'></div>"],
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  dots: false,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },

    1000: {
      items: 2
    }
  }
};
const artistData = [
  {
    id: 1,
    artistImage: pom2089,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Pom2089',
    artistDetails: 'Through the scrapes and bruises, you have to try to heal.. and I think a flower is the best example of that, growing and healing every second. ðŸŒ¸',
    truncate: 'Through the scrapes and bruises, you have to try to heal..',
    showDetails: true,
    twitterName: 'Pom2089',
    artistEmail: 'michaelpompa32@gmail.com',
    twitterLink: 'https://www.twitter.com/Pom2089',
    mailto: 'mailto:michaelpompa32@gmail.com',

  },
  {
    id: 2,
    artistImage: darlyn,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Darlyn Dominguez',
    artistDetails: 'Meditating Waves',
    truncate: 'Meditating Waves',
    showDetails: false,
    twitterName: 'lyndom98',
    artistEmail: 'darlyndominguez14@gmail.com',
    twitterLink: 'https://www.twitter.com/lyndom98',
    mailto: 'mailto:darlyndominguez14@gmail.com',

  },
  {
    id: 3,
    artistImage: galaxy,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'WomenGalaxy',
    artistDetails: 'Full of life Being positive brings good energy in life. She believes in herself and no one can bring her down. She has full control over her mood and thought. Stay positive and make friends that make you smile. You can turn the world into a fantasy the way you imagine it. Positivity is her Power.',
    truncate: 'Full of life Being positive brings good energy in life.',
    showDetails: true,
    twitterName: 'womengalaxy_',
    artistEmail: 'anxa.art@gmail.com',
    twitterLink: 'https://www.twitter.com/womengalaxy_',
    mailto: 'mailto:anxa.art@gmail.com',
  },
  {
    id: 19,
    artistImage: geoff3,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Geoff Grey',
    artistDetails: '“Veteran”. From skateboarding to graffiti to the military, he is no stranger to all walks of life. Upon witnessing the turmoils of war, Veteran retired from the military and committed himself to spreading the ideologies of peace and love across the world in urban settings; inspiring communities with aerosol cans, mop markers, and large-scale wheat paste imagery. He’s considered legendary to all that cross his path.',
    truncate: '“Veteran”. From skateboarding to graffiti to the military...',
    showDetails: true,
    twitterName: 'geoff_grey_art',
    artistEmail: 'Geoffgreybeats@gmail.com',
    twitterLink: 'https://www.twitter.com/geoff_grey_art',
    mailto: 'mailto:Geoffgreybeats@gmail.com',
  },
  {
    id: 4,
    artistImage: reckless,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'NeatlyReckless',
    artistDetails: 'This is Hippie Neatly. As you finally turn your back on one chaotic chapter of your life, and full embrace the vibrate array of opportunities in front of you, you are finally able to heal. Heal from the burnout, the trauma, the toxicity that your last environment left you with, into a new space that will allow you to flourish.',
    truncate: 'This is Hippie Neatly. As you finally turn your back...',
    showDetails: true,
    twitterName: 'neatlyreckless',
    artistEmail: 'neatlyreckless@gmail.com',
    twitterLink: 'https://www.twitter.com/neatlyreckless',
    mailto: 'mailto:neatlyreckless@gmail.com',
  },
  {
    id: 5,
    artistImage: liska,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Jason Liska',
    artistDetails: 'Symbolizing healing through ego death',
    truncate: 'Symbolizing healing through ego death',
    showDetails: false,
    twitterName: 'jpaksil',
    artistEmail: 'jasonliska@shaw.ca',
    twitterLink: 'https://www.twitter.com/jpaksil',
    mailto: 'mailto:jasonliska@shaw.ca',
  },
  {
    id: 6,
    artistImage: choen,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Choen Lee',
    artistDetails: 'An elephantine entity meditates',
    truncate: 'An elephantine entity meditates',
    showDetails: false,
    twitterName: 'ahchoen',
    artistEmail: 'ahchoen@gmail.com',
    twitterLink: 'https://www.twitter.com/ahchoen',
    mailto: 'mailto:ahchoen@gmail.com',
  },
  {
    id: 7,
    artistImage: freakland,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'FreakLand Mamma',
    artistDetails: 'The Journey Within',
    truncate: 'The Journey Within',
    showDetails: false,
    twitterName: 'FreaklandMamma',
    artistEmail: 'freaklandmamma@gmail.com',
    twitterLink: 'https://www.twitter.com/FreaklandMamma',
    mailto: 'mailto:freaklandmamma@gmail.com',
  },
  {
    id: 18,
    artistImage: carsola2,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Will Carsola',
    artistDetails: false,
    truncate: false,
    showDetails: false,
    twitterName: 'WillCarsola',
    artistEmail: 'willcarsola@gmail.com',
    twitterLink: 'https://www.twitter.com/WillCarsola',
    mailto: 'mailto:willcarsola@gmail.com',
  },
  {
    id: 8,
    artistImage: suburban,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Suburban Bombshell',
    artistDetails: 'Peace Love Cannabis',
    truncate: 'Peace Love Cannabis',
    showDetails: false,
    twitterName: 'SUBombshell',
    artistEmail: 'amanda.piche@gmail.com',
    twitterLink: 'https://www.twitter.com/SUBombshell',
    mailto: 'mailto:amanda.piche@gmail.com',
  },
  {
    id: 9,
    artistImage: alyssa,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Alyssa Stevens',
    artistDetails: 'endless space to create in our minds',
    truncate: 'endless space to create in our minds',
    showDetails: false,
    twitterName: 'alyssastevens_',
    artistEmail: 'alyssastevensart@gmail.com',
    twitterLink: 'https://www.twitter.com/alyssastevens_',
    mailto: 'mailto:alyssastevensart@gmail.com',
  },
  {
    id: 10,
    artistImage: baka,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Baka',
    artistDetails: 'This piece reflects power of self healing and how beautiful it can make everything in your surroundings.',
    truncate: 'This piece reflects power of self healing and how beautif...',
    showDetails: true,
    twitterName: 'baka_artist',
    artistEmail: 'fifi.collectionsart@gmail.com',
    twitterLink: 'https://www.twitter.com/baka_artist',
    mailto: 'mailto:fifi.collectionsart@gmail.com',
  },
  {
    id: 11,
    artistImage: mozhgan,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Mozhgan Taeiniya',
    artistDetails: 'My purpose of this image The show of a girl doing yoga is peace and prayer',
    truncate: 'My purpose of this image The show of a girl doing yoga is...',
    showDetails: true,
    twitterName: 'MozhganTaei',
    artistEmail: 'mozhgantaei67@gmail.com',
    twitterLink: 'https://www.twitter.com/MozhganTaei',
    mailto: 'mailto:mozhgantaei67@gmail.com',
  },
  {
    id: 12,
    artistImage: veronicaradd,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Veronicaradd',
    artistDetails: 'Mother Nature Hippie!',
    truncate: 'Mother Nature Hippie!',
    showDetails: false,
    twitterName: 'MozhganTaei',
    artistEmail: 'mozhgantaei67@gmail.com',
    twitterLink: 'https://www.twitter.com/MozhganTaei',
    mailto: 'mailto:mozhgantaei67@gmail.com',
  },
  {
    id: 19,
    artistImage: geoff2,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Geoff Grey',
    artistDetails: '“Veteran”. From skateboarding to graffiti to the military, he is no stranger to all walks of life. Upon witnessing the turmoils of war, Veteran retired from the military and committed himself to spreading the ideologies of peace and love across the world in urban settings; inspiring communities with aerosol cans, mop markers, and large-scale wheat paste imagery. He’s considered legendary to all that cross his path.',
    truncate: '“Veteran”. From skateboarding to graffiti to the military...',
    showDetails: true,
    twitterName: 'geoff_grey_art',
    artistEmail: 'Geoffgreybeats@gmail.com',
    twitterLink: 'https://www.twitter.com/geoff_grey_art',
    mailto: 'mailto:Geoffgreybeats@gmail.com',
  },
  {
    id: 13,
    artistImage: jessica,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Jessica Wild Child',
    artistDetails: 'Don\'t worry, be a happy hippie!',
    truncate: 'Don\'t worry, be a happy hippie!',
    showDetails: false,
    twitterName: 'jesscawildchild',
    artistEmail: 'Mannings.jess@gmail.com',
    twitterLink: 'https://www.twitter.com/jesscawildchild',
    mailto: 'mailto:mannings.jess@gmail.com',
  },
  {
    id: 14,
    artistImage: koinroses,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'KoinRoses',
    artistDetails: 'element of peace',
    truncate: 'element of peace',
    showDetails: false,
    twitterName: 'koinroses',
    artistEmail: 'koinissenroses@gmail.com',
    twitterLink: 'https://www.twitter.com/koinroses',
    mailto: 'mailto:koinissenroses@gmail.com',
  },
  {
    id: 15,
    artistImage: alba,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Alba in the Rainbow',
    artistDetails: 'Surround yourself with good energy. Appreciate the past, focus on the present, dream about the future.',
    truncate: 'Surround yourself with good energy. Appreciate the pas...',
    showDetails: true,
    twitterName: 'Alba_Maria_T',
    artistEmail: 'torregrossa.alba@gmail.com',
    twitterLink: 'https://www.twitter.com/Alba_Maria_T',
    mailto: 'mailto:torregrossa.alba@gmail.com',
  },
  {
    id: 16,
    artistImage: seth,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Seth & Darlyn',
    artistDetails: 'Enlightened Garden Gnome',
    truncate: 'Enlightened Garden Gnome',
    showDetails: false,
    twitterName: 'CheddarBobski',
    artistEmail: 'skotlyar@yahoo.com',
    twitterLink: 'https://www.twitter.com/CheddarBobski',
    mailto: 'mailto:skotlyar@yahoo.com',
  },
  {
    id: 17,
    artistImage: geoff,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Geoff Grey',
    artistDetails: '“Veteran”. From skateboarding to graffiti to the military, he is no stranger to all walks of life. Upon witnessing the turmoils of war, Veteran retired from the military and committed himself to spreading the ideologies of peace and love across the world in urban settings; inspiring communities with aerosol cans, mop markers, and large-scale wheat paste imagery. He’s considered legendary to all that cross his path.',
    truncate: '“Veteran”. From skateboarding to graffiti to the military...',
    showDetails: true,
    twitterName: 'geoff_grey_art',
    artistEmail: 'Geoffgreybeats@gmail.com',
    twitterLink: 'https://www.twitter.com/geoff_grey_art',
    mailto: 'mailto:geoffgreybeats@gmail.com',
  },
  {
    id: 17,
    artistImage: carsola,
    userIcon: user,
    twitterIcon: artistTwitter,
    emailIcon: mail,
    quoteIcon: artistQuote,
    artistName: 'Will Carsola',
    artistDetails: false,
    truncate: false,
    showDetails: false,
    twitterName: 'WillCarsola',
    artistEmail: 'willcarsola@gmail.com',
    twitterLink: 'https://www.twitter.com/WillCarsola',
    mailto: 'mailto:willcarsola@gmail.com',
  },
]
function createMarkup(c) {
  return { __html: c };
}
const ArtistCard = (props) => {
  const { artistD } = props;
  const { id, artistImage, userIcon, twitterIcon, emailIcon, quoteIcon, artistName, artistDetails, twitterName, artistEmail, truncate, showDetails, twitterLink, mailto } = artistD;
  const [cardFlipper, setCardFlipper] = useState(false)
  const flipCard = () => {
    setCardFlipper(!cardFlipper)
  }
  return (
    <>
      <div className="s-body">
        <div className={cardFlipper ? 'flip-card flipped ' : 'flip-card'}>
          <div className="flip-card-inner">
            <div className="flip-card-front">

              <div className="s-img">
                <img src={artistImage} alt="" />
              </div>
            </div>
            <div className="flip-card-back">
              <p dangerouslySetInnerHTML={createMarkup(artistDetails)}></p>
              <button onClick={flipCard}>... <b>{cardFlipper ? 'back' : 'more'}</b> </button>
            </div>
          </div>
        </div>
        <div className="s-details">
          <span className="user details">
            <span className="user-icon">
              <img src={userIcon} alt="" />
            </span>
            <span className="user-text">{artistName}</span>
          </span>
          {
            !artistDetails ? '' :
              !showDetails ?
                <span className="quote details">
                  <span className="quote-icon">
                    <img src={quoteIcon} alt="" />
                  </span>
                  <div className="text-toggle">
                    <p className="quote-text read-more-wrap">{truncate}</p>
                  </div>
                </span> :
                <span className="quote details">
                  <span className="quote-icon">
                    <img src={quoteIcon} alt="" />
                  </span>
                  <div className="text-toggle">
                    <p className="quote-text read-more-wrap">{truncate}</p>
                    <button onClick={flipCard}>... <b>{cardFlipper ? 'back' : 'more'}</b></button>
                  </div>
                </span>
          }
          <span className="twitter details">
            <span className="twitter-icon">
              <img src={twitterIcon} alt="" />
            </span>
            <span className="twitter-text"><a href={twitterLink} target="_black">{twitterName}</a></span>
          </span>
          <span className="mail details">
            <span className="mail-icon">
              <img src={emailIcon} alt="" />
            </span>
            <span className="mail-text"><a href={mailto}>{artistEmail}</a></span>
          </span>
        </div>
      </div>
    </>
  )
}


const ArtistCardMobile = (props) => {
  const { artistD } = props;
  const { id, artistImage, userIcon, twitterIcon, emailIcon, quoteIcon, artistName, artistDetails, twitterName, artistEmail, truncate, showDetails, twitterLink, mailto } = artistD;
  const [cardFlipper, setCardFlipper] = useState(false)
  const flipCard = () => {
    setCardFlipper(!cardFlipper)
  }

  return (
    <>
      <div className="s-body">
        <div className="s-img">
          <img src={artistImage} alt="" />
        </div>
        <div className={cardFlipper ? 'flip-card flipped ' : 'flip-card'}>
          <div className="flip-card-inner">
            <div className="flip-card-front">
              <div className="s-details">
                <span className="user details">
                  <span className="user-icon">
                    <img src={userIcon} alt="" />
                  </span>
                  <span className="user-text">{artistName}</span>
                </span>
                {
                  !artistDetails ? '' :
                    !showDetails ?
                      <span className="quote details">
                        <span className="quote-icon">
                          <img src={quoteIcon} alt="" />
                        </span>
                        <div className="text-toggle">
                          <p className="quote-text read-more-wrap">{truncate}</p>
                        </div>
                      </span> :
                      <span className="quote details">
                        <span className="quote-icon">
                          <img src={quoteIcon} alt="" />
                        </span>
                        <div className="text-toggle">
                          <p className="quote-text read-more-wrap">{truncate}</p>
                          <button onClick={flipCard}>... <b>{cardFlipper ? 'back' : 'more'}</b></button>
                        </div>
                      </span>
                }
                <span className="twitter details">
                  <span className="twitter-icon">
                    <img src={twitterIcon} alt="" />
                  </span>
                  <span className="twitter-text"><a href={twitterLink} target="_black">{twitterName}</a></span>
                </span>
                <span className="mail details">
                  <span className="mail-icon">
                    <img src={emailIcon} alt="" />
                  </span>
                  <span className="mail-text"><a href={mailto}>{artistEmail}</a></span>
                </span>
              </div>
            </div>
            <div className="flip-card-back">
              <p dangerouslySetInnerHTML={createMarkup(artistDetails)}></p>
              <button onClick={flipCard}>... <b>{cardFlipper ? 'back' : 'more'}</b> </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
function ArtistSlider() {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <section id="artist">
      <div className="wrapper">
        <h2 data-aos="fade-up" data-aos-delay="300">Artist Collabs</h2>
        <div className="slider for-desktops">
          <OwlCarousel className="artis-slider  owl-theme" {...options}>
            {artistData.map((artistD, index) => {
              return (
                <div key={index}>
                  <ArtistCard
                    artistD={artistD}
                  />
                </div>
              );
            })}
          </OwlCarousel>
        </div>
        <div className="slider for-mobiles">
          <OwlCarousel className="artis-slider  owl-theme" {...options}>
            {artistData.map((artistD, index) => {
              return (
                <div key={index}>
                  <ArtistCardMobile
                    artistD={artistD}
                  />
                </div>
              );
            })}
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
}

export default ArtistSlider;
